import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const OverviewSummaryContext = createContext(null);

type Props = {
  children: ReactElement;
};

const OverviewSummaryProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["overview_summary"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`overview?keyword=main`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      error,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <OverviewSummaryContext.Provider value={contextValue}>
      {children}
    </OverviewSummaryContext.Provider>
  );
};

export default OverviewSummaryProvider;
